export default {
  version: 'alpha',
  // downForMaintenance: true,
  // showNotesInNav: true, //. ditched?
  // showNotesInline: true,
  showNotesFlag: true, //?
}
